'use client';

import React from 'react';
import styles from '@/module-public/pages/product-landing/product-landing.module.scss';
import HeroSection from '@/module-public/pages/mcp-page/sections/HeroSection';
import WhatIsMcpSection from '@/module-public/pages/mcp-page/sections/WhatIsMcpSection';
import ToolsListSection from '@/module-public/pages/mcp-page/sections/ToolsListSection';
import SetupSection from '@/module-public/pages/mcp-page/sections/SetupSection';
import BenchmarkSection from '@/module-public/pages/mcp-page/sections/BenchmarkSection';
import WhoIsItForSection from '@/module-public/pages/mcp-page/sections/WhoIsItForSection';
import PrivacySection from '@/module-public/pages/mcp-page/sections/PrivacySection';
import FinalCtaSection from '@/module-public/pages/mcp-page/sections/FinalCtaSection';

export default function McpPageClient() {
  return (
    <main className={styles.page}>
      <HeroSection />
      <WhatIsMcpSection />
      <ToolsListSection />
      <SetupSection />
      <BenchmarkSection />
      <WhoIsItForSection />
      <PrivacySection />
      <FinalCtaSection />
    </main>
  );
}
